import axios from "lib/axios";

export const loadDocumentsApi = async (building_id) => {
  return await axios.get(`/minutes/buildings/${building_id}/documents.json`);
};

export const downloadDocumentApi = async ({building_id, document_id}) => {
  return await axios.get(`/minutes/buildings/${building_id}/documents/${document_id}/download`)
}
